import Vuex from 'vuex';
import Vue from 'vue';
import auth from './modules/auth.js'

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        auth
    }
})